<template>
  <save-comparison
    v-show="canSaveComparison"
    :filters="filters"
    :products="products"
    :location="location"
  >
    <template #confirmation>
      <div
        v-if="savedComparison"
        class="bubble"
      >
        <icon
          icon="check-circle-solid"
          size="sm"
        />
        <span class="text">{{ confirmationMessage }}</span>
      </div>
    </template>
    <template #modal>
      <save-complete-modal
        v-if="savedComparison"
        v-model:comparison="comparison"
        v-model:receiver="receiver"
        :saved-comparison="savedComparison"
        market-type="internet"
      >
        <template #market-usps>
          <div class="usp">
            <icon icon="router-regular" />
            <span> {{ internetUsp }}</span>
          </div>
        </template>
      </save-complete-modal>
      <component
        :is="modalType"
        v-else
        v-model:comparison="comparison"
        v-model:receiver="receiver"
        market-type="internet"
        @complete="comparisonSaved"
        @nextStep="nextStep"
        @previousStep="previousStep"
      >
        <template #market-usps>
          <div class="usp">
            <icon icon="router-regular" />
            <span> {{ internetUsp }}</span>
          </div>
        </template>
      </component>
    </template>
  </save-comparison>
</template>
<script>

import Icon from 'vue-elements/icon/Icon.vue';
import SaveComparison from '../../../../abstracts/components/saveComparisonModal/SaveComparison.vue';
import SaveCompleteModal from '../../../../abstracts/components/saveComparisonModal/modals/SaveCompleteModal.vue';
import SaveComparisonModal from '../../../../abstracts/components/saveComparisonModal/modals/SaveComparisonModal.vue';
import EmailComparisonModal from '../../../../abstracts/components/saveComparisonModal/modals/EmailComparisonModal.vue';
import saveComparison from '../../../../abstracts/components/saveComparisonModal/assets/js/saveComparison.js';
import ButtonIconRight from '../../../../abstracts/elements/button/icon-right/button-icon-right.vue';
import ModalCenter from '../../../../abstracts/elements/modal/center/modalCenter.vue';
import PickReceiverModal from '../../../../abstracts/components/saveComparisonModal/modals/PickRecieverModal.vue';

export default {
    name: 'SaveInternetComparison',
    components: {
        PickReceiverModal,
        EmailComparisonModal,
        SaveComparisonModal,
        SaveCompleteModal,
        SaveComparison,
        ModalCenter,
        ButtonIconRight,
        Icon,
    },
    mixins: [saveComparison],
    computed: {
        internetUsp() {
            if (this.filters.productType === 'itp') {
                return 'Alles in 1';
            } if (this.filters.productType === 'it') {
                return 'Internet & Televisie';
            }
            return 'Alleen internet';
        },

        confirmationMessage() {
            return this.signedIn ? 'Deze vergelijking is bewaard' : 'Deze vergelijking is gemaild';
        },

    },
    mounted() {
        // Temp fix to disable floating button from floating over modal
        this.$root.$el.querySelector('input#save-comparison')
            .addEventListener('change', (el) => {
                this.$root.$el.querySelector('.floating-panel').style.display = el.target.checked ? 'none' : 'revert';
            });
    },
};
</script>
